export const tr = {
    'accept-button': 'Aç',
    'simple-progress-hint': 'Otomatik hedefleme etkinleştiriliyor...',
    'simple-title': 'Otomatik hedeflemeyi etkinleştirin',
    'title-hint':
        'Reklamlarınız için anahtar sözcük grupları ayarlanmadığı veya tıklama başına fiyat (CPC) değeri çok yüksek olduğu için bu öneriyi görüyorsunuz'
};
